<script>
	export let sort;
	export let toggleSort;
	export let column;
</script>

<button
	style="border: none; background-color: transparent;"
	on:keydown={() => {}}
	tabindex="0"
	on:click={() => toggleSort(column)}
>
	{#if sort.desc === "asc" && sort.column === column}
		<img src="/assets/icon-sort-up-thin.svg" alt="icon-sort-up" />
	{:else}
		<img src="/assets/icon-sort-down-thin.svg" alt="icon-sort-down" />
	{/if}
</button>
